import React from 'react'
import { Spinner } from 'react-bootstrap'

export const LoadingSpinner = () => 
    <Spinner animation='border' role='status' />
